import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import Select from 'react-select';
/* actions */
import { addBreeds } from '../../redux/actions/breeds';
import { getAllSpecies } from '../../redux/actions/species';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
import ModalAddSpecie from '../../components/ModalAddSpecie';
/* form-validation */
import schema from '../../form-validation/breed';
/* utils */
import {
  customStyle,
  customThemes,
  customFilter,
  firstOption,
  handleChangeSelect
} from '../../utils/select';
import sortable from '../../utils/sortable';
import handleChangeDefault from '../../utils/handleChangeDefault';

function Add (props) {
  const { handleModalClose } = props;
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset, setError, setValue } = useForm(
    {
      validationSchema: schema,
      reValidateMode: 'onSubmit'
    }
  );
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const breeds = useSelector(state => state.breeds);
  const INITIAL_VALUES = {
    name: '',
    specie: '',
    company
  };
  const [data, setData] = useState(INITIAL_VALUES);
  const species = useSelector(state => state.species.data);
  const [specieOptions, setSpecieOptions] = useState([firstOption]);
  const [showModalAddSpecie, setShowModalAddSpecie] = useState(false);

  useEffect(() => {
    dispatch(getAllSpecies({ company }));
  }, [dispatch]);

  useEffect(() => {
    if (species.length) {
      const options = species
        .map(specie => ({
          value: specie._id,
          label: `${specie.name}`,
          sortValue: `${specie.name}`
        }))
        .sort(sortable);

      options.unshift(firstOption);
      setSpecieOptions([...options]);
    }
  }, [species, setSpecieOptions]);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
    };
    dispatch(addBreeds(data, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      <ModalAddSpecie
        showModal={showModalAddSpecie}
        handleModalClose={() => setShowModalAddSpecie(false)}
      />
      {breeds.addSuccess && (
        <AlertMsg type="success" msg="Raça cadastrada com sucesso" />
      )}
      {breeds.errorContent &&
        !breeds.errorContent.message.includes('400') &&
        breeds.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro da raça" />
      )}
      {breeds.errorContent &&
        breeds.errorContent.message.includes('400') &&
        breeds.addError && (
        <AlertMsg
          type="danger"
          msg="Uma raça com o nome informado já está cadastrada"
        />
      )}
      {!breeds.addSuccess && !breeds.addError && (
        <AlertMsg type="info" msg="Área cadastro de raças" />
      )}
      <FormHeader title="Cadastrar Raça" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <div className="form-group form-inline mb-0">
            <label className="col-sm-12 d-inline p-0 mb-2" htmlFor="specie">
              Espécie
              <span className="field-required">*</span>
            </label>
            <Select
              className="col p-0"
              name="breed-specie"
              ref={register}
              onChange={evt =>
                handleChangeSelect(
                  { ...evt, name: 'specie' },
                  data,
                  setData,
                  setError,
                  setValue
                )
              }
              defaultValue={specieOptions[0]}
              value={specieOptions.find(specie => specie.value === data.specie)}
              options={specieOptions}
              isSearchable={true}
              theme={customThemes}
              styles={customStyle}
              filterOption={customFilter}
              noOptionsMessage={() => 'Nenhum registro encontrado'}
            />
            <div className="pl-2">
              <button
                type="button"
                className="btn btn-success"
                title="Adicionar Espécie"
                disabled={showModalAddSpecie}
                onClick={() => setShowModalAddSpecie(true)}
              >
                <i className="fa fa-plus" />
                &nbsp;Espécie
              </button>
            </div>
          </div>
          {errors.specie && errors.specie.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        {handleModalClose ? (
          <div className="container-fluid p-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleModalClose}
            >
              <i className="fa fa-times"></i>
              &nbsp;Fechar
            </button>
            <button
              type="submit"
              ref={submitButton}
              className="btn btn-primary float-right"
            >
              <i className="fa fa-save"></i>
              &nbsp;Salvar
            </button>
          </div>
        ) : (
          <FormFooter url="/breeds" reference={submitButton} />
        )}
      </form>
    </div>
  );
}

Add.propTypes = {
  handleModalClose: PropTypes.func
};

export default Add;
